/**
 * App-wide error-reporting seam. Defaults to a console reporter; an app swaps in
 * a real backend (e.g. Sentry's `captureException`) once via {@link setErrorReporter}.
 * Boundaries and the data layer call {@link reportError} instead of logging directly.
 */

/** Free-form context attached to a report (e.g. `{ path: 'seasons' }`). */
export type JcErrorContext = Record<string, unknown>;

export type JcErrorReporter = (error: unknown, context?: JcErrorContext) => void;

const consoleReporter: JcErrorReporter = (error, context) => {
    console.error('Reported error:', error, context ?? {});
};

let reporter: JcErrorReporter = consoleReporter;

/** Installs the app's reporter (e.g. wired to Sentry). Replaces the default. */
export const setErrorReporter = (fn: JcErrorReporter): void => {
    reporter = fn;
};

/** Routes an error through the installed reporter. */
export const reportError = (error: unknown, context?: JcErrorContext): void => {
    reporter(error, context);
};
